module.exports = __webpack_public_path__ + "img/ata-line.b27338a3.png";